import { seeJSXOfNode } from "@builder/assist/services/tools/globalTools";
import { CommonPageType } from "@builder/utils/JSXtoBuilder/architecture/pagesAndComponentsInfo";
import { streamText, type StreamTextOnChunkCallback, type CoreMessage } from "ai";
import { model } from "../../useAiChat";
import { getLayerById } from "../helpers";
import { generateDesignInstructionsPrompt } from "./designAIPrompts";
import { generateDesignAIToolset } from "./designAIToolset";



export const editDesignWithAI = async ({
    userPrompt,
    startingNodeId,
    layerId,
    pageType,
    onChunk,
    abortSignal
}: {
    userPrompt: string;
    startingNodeId?: string;
    layerId: string; 
    pageType?: CommonPageType;
    onChunk?: StreamTextOnChunkCallback<any>;
    abortSignal?: AbortSignal;
}) => {
    console.log(`editing design with AI, user prompt: ${userPrompt}, starting node id: ${startingNodeId}, layer id: ${layerId}, page type: ${pageType}`);
    const layerDetails = getLayerById(layerId);
    if (!layerDetails) {
        console.error("Layer not found", layerId);
       return "error: Layer not found; Make sure the layer is valid";
    }
    if (!startingNodeId) {
        startingNodeId = layerDetails.layer.root;
    }

    const currentJSX = seeJSXOfNode(layerId, startingNodeId);
    if (!currentJSX) {
        console.error("Current JSX not found", startingNodeId);
        return `error: I could not see the current JSX of the node ${startingNodeId} in the layer ${layerId}, try to give me a better node id and make sure the layer ID is valid`;
    }

    const systemPrompt = generateDesignInstructionsPrompt({ pageType, pageName: layerDetails.layer.name, layerType: layerDetails.type });

    const messages: CoreMessage[] = [
        {
            role: "system",
            content: systemPrompt,
        },
        {
            role: "system",
            content: `this is the JSX you are editing: ${currentJSX}`
        },
        {
            role: "user",
            content: userPrompt
        }
    ]


    let result = "";

    const { textStream } = streamText({
        model,
        messages,
        tools: generateDesignAIToolset({ layerId, startingNodeId }),
        onChunk,
        maxSteps: 15,
        abortSignal
    });

    // Ensure we consume the stream to completion if not already
    for await (const chunk of textStream) {
        result += chunk;
    }

    return result;
};

